import { render, staticRenderFns } from "./UploadOthers.vue?vue&type=template&id=77841f5a&scoped=true"
import script from "./UploadOthers.vue?vue&type=script&lang=ts"
export * from "./UploadOthers.vue?vue&type=script&lang=ts"
import style0 from "./UploadOthers.vue?vue&type=style&index=0&id=77841f5a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77841f5a",
  null
  
)

export default component.exports